import { I18n } from "i18n-js";
import { getLocale } from "./html.js";
import translations from "./translations.json";

const i18n = new I18n(translations);
i18n.defaultLocale = "de";
i18n.enableFallback = true;
i18n.locale = getLocale();

export default i18n;
export const t = i18n.t.bind(i18n);
